interface EnumDotEntry {
  dot: string;
  description: string;
}

// Enum values are read/written as a dotted `Flavor.MEMBER` string (e.g. "LoanStatus.DELINQUENT") —
// that form is for storage/comparison only. Humanize it against the flavor's fetched enum list
// before showing it to a user, falling back to the raw dot while the list is loading or unmatched.
export function humanizeEnumDot(
  enums: EnumDotEntry[] | undefined | null,
  dot: string | null | undefined
): string {
  if (!dot) return '';
  const match = enums?.find((entry) => entry.dot === dot);
  return match?.description ?? dot;
}
